import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { rodneCisloRegExp } from 'enums/regExp';

export const validateRdc = (rdc: string) => {
    // 0 - OK
    // 1 - E: nezadano
    // 2 - E: chybna syntaxe
    // 3 - E: vadne datum
    // 4 - E: prestupny rok
    // 5 - E: extra rozsah
    // 6 - E: jeste nenarozen
    // 7 - W: zrejme zemrel
    // 8 - E: chybna kontrolka
    // 9 - W: vyjimka kontrolky
    const daysinmonth = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (!rdc) return 1; // nezadano

    const len = rdc.length;
    if (len < 9) return 2; // chybna syntaxe

    const testRdc = rodneCisloRegExp;
    if (!testRdc.test(rdc)) return 2; // chybna syntaxe

    // parsovani
    let yea = parseInt(rdc.substring(0, 2));
    let mon = parseInt(rdc.substring(2, 4));
    const day = parseInt(rdc.substring(4, 6));
    const num = parseInt(rdc);
    // od 1954-01-01 koncovka 4 znaky
    if (len == 10) yea += yea >= 54 ? 1900 : 2000;
    // do 1953-12-31 koncovka 3 znaky
    if (len == 9) yea += yea < 54 ? 1900 : 1800;
    // zensky rozsah
    if (mon > 50) mon -= 50;
    // od 2004-01-01 mozny extra rozsah
    if (yea < 2004 && mon > 20) return 5; // extra rozsah
    // extra rozsah
    if (mon > 20) mon -= 20;
    // kontrola hodnot
    if (mon < 1 || mon > 12 || day < 1 || day > daysinmonth[mon - 1]) return 3; // vadne datum
    // prestupny rok
    if (mon == 2 && day == 29) if (yea % 4 != 0 || (yea % 100 == 0 && yea % 400 != 0)) return 4; // prestupny rok
    // kontrola kalendare
    const cal = new Date(yea, mon - 1, day, 0, 0, 0, 0); // az tady js month
    const tmp = new Date();

    if (cal > tmp) return 6; // jeste nenarozen

    tmp.setFullYear(tmp.getFullYear() - 100);
    if (cal < tmp) return 7; // zrejme zemrel

    // kontrolni cislice
    if (len == 10 && num % 11 != 0) {
        // Vyjimka:
        // Asi 1000 rodnych cisel vydanych do roku 1985.
        // Kdyz zbytek po deleni devitimistneho cisla je roven 10,
        // tak se jako kontrolni cislice se pouzila nula.
        // Cele rodne cislo pak neni delitelne jedenacti.
        // Zrusil Federalniho statisticky urad predpisem č. Vk. 2898/1985.
        // Napriklad: 7801233540 nebo 6362310010
        if (yea <= 1985 && num % 10 == 0 && (num / 10) % 11 == 10) return 9; // vyjimka kontrolky
        return 8; // chybna kontrolka
    }

    return 0;
};

export const rodneCisloValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || !validateRdc(value) || validateRdc(value) === 7) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_RC</TranslateText>);
        }
    })
];

export default rodneCisloValidation;
